export default __webpack_public_path__ + "static/WhyteRegular-2eef56287389180e76ab95fb8b3851cf.woff";